module.exports = __webpack_public_path__ + "img/1.4a3ecd9a.gif";